import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isContactEnrichment", "maxInlineSize"];
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button, EmptyState, LayoutBox, LayoutHorizontal, LayoutSpaceVertical, Modal } from 'breeze-intelligence-kit';
import { useCurrentUser } from 'policy-lib';
import { NoAccessModalEmptyState, NoAccessModalEmptyStateHeader } from '../NoAccess/NoAccessModalEmptyState';
import { NoAccessPanelEmptyState } from '../NoAccess/NoAccessPanelEmptyState';
import { MAX_INLINE_SIZE } from '../NoAccess/constants';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Text = styled(LayoutBox).withConfig({
  displayName: "EnrichmentNoAccessUpdateSettings__Text",
  componentId: "sc-8pduv-0"
})(["text-wrap:pretty;"]);
const EnrichmentNoAccessUpdateSettings = ({
  children,
  isContactEnrichment,
  maxInlineSize = MAX_INLINE_SIZE
}) => {
  const {
    companyLabelLowercase,
    contactLabelLowercase
  } = useEnrichableObjectTypes();
  return /*#__PURE__*/_jsx(LayoutHorizontal, {
    justifyContent: "center",
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: "space-md",
      maxInlineSize: maxInlineSize,
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "p",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.permissions.noAccessManual",
          options: {
            objectType: isContactEnrichment ? contactLabelLowercase : companyLabelLowercase
          }
        }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.permissions.noAccessUpdateSettings"
        })]
      }), children]
    })
  });
};
const EnrichmentNoAccessUpdateSettingsLink = () => {
  const currentUser = useCurrentUser();
  const settingsURL = `/settings/${currentUser.portalId}/enrichment`;
  return /*#__PURE__*/_jsx(Button, {
    external: true,
    href: settingsURL,
    target: "_blank",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentProperties.permissions.updateSettings"
    })
  });
};
export const EnrichmentNoAccessUpdateSettingsModal = ({
  isContactEnrichment
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(NoAccessModalEmptyStateHeader, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentProperties.permissions.noAccessTitle"
    })
  }), /*#__PURE__*/_jsx(NoAccessModalEmptyState, {
    children: /*#__PURE__*/_jsx(EnrichmentNoAccessUpdateSettings, {
      isContactEnrichment: isContactEnrichment
    })
  }), /*#__PURE__*/_jsx(Modal.Footer, {
    children: /*#__PURE__*/_jsx(EnrichmentNoAccessUpdateSettingsLink, {})
  })]
});
export const EnrichmentNoAccessUpdateSettingsPanel = _ref => {
  let {
      isContactEnrichment,
      maxInlineSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(NoAccessPanelEmptyState, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(EmptyState.Title, {
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.permissions.noAccessTitle"
      })
    }), /*#__PURE__*/_jsx(EnrichmentNoAccessUpdateSettings, {
      isContactEnrichment: isContactEnrichment,
      maxInlineSize: maxInlineSize,
      children: /*#__PURE__*/_jsx(EnrichmentNoAccessUpdateSettingsLink, {})
    })]
  }));
};